
import { createRouter, createWebHistory } from 'vue-router'
import { authGuard} from '@auth0/auth0-vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('@/components/SplashPage.vue'),
		meta: {
			title: 'OE Alternatives – Mobile Automotive Programming in Utah',
			description: 'Professional mobile automotive module programming in Utah. OE Alternatives provides on-site programming plus high-quality replacement modules.',
			canonical: 'https://oealternatives.com'
		}
	},
	{
		path: '/MobileVehicleProgramming',
		name: 'MobileVehicleProgramming',
		component: () => import('@/components/PublicFace/Programming/MobileVehicleProgramming.vue'),
		meta: {
			title: 'OE Alternatives – Mobile Automotive Programming in Utah – On-Site ECU, PCM & TCM Services',
			description: 'Fast, reliable mobile automotive module programming in Utah. OE Alternatives offers on-site ECU, PCM, BCM, and TCM programming for domestic, European, and Asian vehicles. We come to your shop or location—no towing required.',
			canonical: 'https://oealternatives.com/MobileVehicleProgramming'
		}

	},
	{
		path: '/MobileProgramming',
		name: 'MobileProgramming',
		component: () => import('@/components/PublicFace/Programming/MobileProgramming.vue'),
		meta: {
			title: 'OE Alternatives – Mobile Automotive Programming in Utah – On-Site ECU, PCM & TCM Services',
			description: 'Fast, reliable mobile automotive module programming in Utah. OE Alternatives offers on-site ECU programming for domestic, European, and Asian vehicles.',
			canonical: 'https://oealternatives.com/MobileProgramming'
		}
	},
	{
		path: '/MobileProgramming/CheckUpdates',
		name: 'CheckUpdates',
		component: () => import('@/components/PublicFace/Programming/UpdateChecker.vue'),
		meta: {
			title: 'PCM & TCM Update Lookup Tool | Check Calibration Updates',
			description: 'Check for PCM and TCM software updates by calibration ID. Supports Chrysler, Nissan, Toyota, and Subaru vehicles.',
			canonical: 'https://oealternatives.com/MobileProgramming/CheckUpdate'
		}
	},
	{
		path: '/MobileProgramming/RequestProgramming',
		name: 'RequestProgramming',
		component: () => import('@/components/PublicFace/Programming/RequestProgramming/RequestProgrammingPage.vue'),
		beforeEnter: authGuard
	},
	{
		path: '/MobileProgramming/EmployeeUpdateLookup',
		name: 'EmployeeUpdateLookup',
		component: () => import('@/components/PartsProcessing/EmployeeUpdateLookup.vue')
	},
	{
		path: '/Modules',
		name: 'ModulesSplashpage',
		component: () => import('@/components/PublicFace/Inventory/InventoryLandingPage.vue'),
		meta: {
			title: 'OE Alternatives – Automotive ECM & PCM Modules – Order Today',
			description: 'Browse OE Alternatives’ inventory of automotive ECM and PCM modules. Receive a personalized consultation with pricing. Serving customers nationwide.',
			canonical: 'https://oealternatives.com/Modules'
		}
	},
	{
		path: '/Account/Contact',
		name: 'ContactInfo',
		component: () => import('@/components/PublicFace/UserContactInfoPage.vue'),
		beforeEnter: authGuard
	},
	{
		path: '/Account/MyOrders',
		name: 'MyOrders',
		component: () => import('@/components/PublicFace/Inventory/MyOrders.vue'),
		beforeEnter: authGuard
	},
	{
		path: '/Account/MyRequests',
		name: 'MyRequests',
		component: () => import('@/components/PublicFace/Programming/RequestProgramming/MyRequests.vue'),
		beforeEnter: authGuard
	},

	{
		path: '/Dashboard',
		name: 'Dashboards',
		component: () => import('../components/UserDashboard.vue'),
		beforeEnter: authGuard
	},
	{
		path:'/Map',
		name:'Map',
		component: () => import ("../components/MapComponent.vue")
	},

	{
		path: '/Jobs',
		name: 'Jobs',
		component: () => import('@/components/Jobs/JobsTable'),
		meta: { permissions: ["read:jobs"] },
		beforeEnter: authGuard
	},
	{
		path: '/JobRequests',
		name: 'JobRequests',
		component: () => import('@/components/Jobs/JobRequestTable.vue'),
		meta: { permissions: ["read:jobs"] },
		beforeEnter: authGuard
	},
	{
		path: '/Calls',
		name: 'Calls',
		component: () => import('@/components/Calls/CallsTable.vue'),
		meta: { permissions: ["read:jobs"] },
		beforeEnter: authGuard
	},
	{
		path: '/Customers',
		name: 'Customers',
		component: () => import('@/components/Customers/CustomersTable.vue'),
		meta: { permissions: ["read:customers"] },
		beforeEnter: authGuard,
	},
	{
		path: '/Advertising',
		name: 'Advertising',
		component: () => import('@/components/Advertising/AdvertisingTable.vue'),
		meta: { permissions: ['read:customers']},
		beforeEnter: authGuard
	},
	{
		path: '/Employees',
		name: 'Employees',
		component: () => import('../components/Employees/EmployeesTable.vue'),
		meta: { permissions: ["read:employees"] },
		beforeEnter: authGuard
	},
	{
		path: '/Notes',
		name: 'Notes',
		component: () => import('../components/Notes/NotesTableViewer.vue'),
		meta: {permissions: ['read:jobs']},
		beforeEnter: authGuard
	},
	{
		path: '/Invoices',
		name: 'Invoices',
		component: () => import('../components/Billing/InvoiceTable.vue'),
		meta: {permissions: ['read:jobs']},
		beforeEnter: authGuard
	},
	{
		path: '/Payments',
		name: 'Payments',
		component: () => import('../components/Billing/PaymentTable.vue'),
		meta: {permissions: ['read:jobs']},
		beforeEnter: authGuard
	},
	{
		path: '/Services',
		name: 'Services',
		component: () => import('../components/Billing/Services/ServicesTable.vue'),
		meta: {permissions: ['read:jobs']},
		beforeEnter: authGuard
	},
	{
		path: '/ResourceCenter',
		name: 'ResourcesCenter',
		component: () => import('../components/Resources/ResourceCenter.vue'),
		beforeEnter: authGuard
	},
	{
		path: '/Resources',
		name: 'Resources',
		component: () => import('../components/Resources/UserResources.vue'),
		beforeEnter: authGuard
	},
	{
		path:'/Resources/:resource',
		name: 'ViewResource',
		component: () => import('../components/Resources/ViewResource.vue'),
		beforeEnter: authGuard
	},
	// {
	// 	path: '/Utilities',
	// 	name: 'Utilities',
	// 	component: ()=> import('../components/Utilities/UtilitiesDownloads.vue'),
	// 	meta: { permissions: 'download:utilities'},
	// 	beforeEnter: authGuard
	// },
	{
		path: '/Users',
		name: 'Users',
		component: () => import('@/components/Admin/Users/UsersTable.vue'),
		meta: { permissions: ["admin"] },
		beforeEnter: authGuard
	},
	{
		path: '/Messages',
		name: 'Messages',
		component: () => import('@/components/Admin/Messages/MessagesTable.vue'),
		meta: { permissions: ["admin"] },
		beforeEnter: authGuard
	},
	{
		path: '/CVT/Create',
		name: 'CVTCreator',
		component: () => import('@/components/Utilities/CVTFileCreator.vue'),
		meta: { permissions: ["edit:cvt"] },
		beforeEnter: authGuard
	},
	{
		path: '/CVT/Download',
		name: 'CVTDownload',
		component: () => import('@/components/Utilities/CVTFileDownloader.vue'),
		meta: { permissions: ["edit:cvt"] },
		beforeEnter: authGuard
	},
	{
		path: '/TestPage',
		name: 'TestPage',
		component: () => import('../components/TestPage.vue'),
		meta: { permissions: ["testing"] },
		beforeEnter: authGuard
	},
	{
		path: '/Quickbooks',
		name: 'QuickbooksMain',
		component: () => import('../components/Quickbooks/QuickbooksMainPage.vue'),
		meta: { permissions: ["admin"]},
		beforeEnter: authGuard
	},
	{
		path: '/Quickbooks/Connection',
		name: 'QuickbooksConnection',
		component: ()=> import('../components/Quickbooks/QuickbooksConnectionPage.vue')
	},
	{
		path: '/Quickbooks/LinkCustomers',
		name: 'LinkCustomers',
		component: ()=> import('../components/Quickbooks/LinkCustomers.vue'),
		meta: {permissions: ["admin"]},
		beforeEnter: authGuard
	},
	{
		path:'/Quickbooks/EULA',
		name:"EULAPage",
		component: ()=> import('../components/Quickbooks/EULAPage.vue'),
		beforeEnter: authGuard
	},
	{
		path:'/Quickbooks/PrivacyPolicy',
		name:"PrivacyPolicy",
		component: () => import('../components/Quickbooks/PrivacyPolicy.vue'),
		beforeEnter:authGuard
	},
	{
		path:'/TSBProcessing',
		name:'TSBProcessing',
		component: () => import('../components/PartsProcessing/TSBProcessingMainPage.vue'),
		meta: { permissions: ["process:tsb"] },
		beforeEnter: authGuard
	},
	{
		path:'/IntakeForm',
		name:'IntakeForm',
		component: () => import('../components/PartsProcessing/PartIntakePage.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/InventoryTable',
		name:'InventoryTable',
		component: () => import('../components/PartsProcessing/PartsTable.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/Inventory/ListCreator',
		name: 'ListCreator',
		component: () => import('../components/PartsProcessing/ListCreator.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/Inventory/PrepModule',
		name: 'PrepModule',
		component: () => import('../components/PartsProcessing/Prep&Instructions/ModuleIdentifierPage.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/Inventory/PrepModule/Instructions/Temp',
		name: 'PrepModuleInstructionsTemp',
		component: () => import('../components/PartsProcessing/Prep&Instructions/ViewPrepInstructionsTemp.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard,
		props: true
	},
	{
		path:'/Inventory/PrepModule/Instructions/:instruction_id',
		name: 'PrepModuleInstructions',
		component: () => import('../components/PartsProcessing/Prep&Instructions/ViewPrepInstructions.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard,
		props: true
	},
	{
		path:'/InputLog',
		name:'InputLog',
		component: () => import('../components/PartsProcessing/InputLogTable.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/TextExtractor',
		name:'TextExtractor',
		component: () => import('../components/PartsProcessing/TextExtracting.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/Orders',
		name:'Orders',
		component: () => import('../components/PartsProcessing/OrdersTable.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/EmployeePortal',
		name:'EmployeePortal',
		component: () => import('../components/EmployeePortal.vue'),
		meta:{ permissions: ['isEmployee']},
		beforeEnter: authGuard
	},
	{
		path:'/Products',
		name:'Products',
		component: () => import('../components/Products/ProductsTable.vue'),
		meta:{ permissions: ['isEmployee']},
		beforeEnter: authGuard
	},
	{
		path: '/Shop/Cart',
		name: 'SubmitOrder',
		component: () => import('@/components/PublicFace/Inventory/SubmitOrder.vue'),
	},
	{
		path: '/Shop/PrivacyPolicy',
		name: 'ShopPrivacyPolicy',
		component: () => import('@/components/PublicFace/PrivacyPolicy.vue'),
	},
	{
		path: '/Shop/Payment-Success',
		name: 'PaymentSuccess',
		component: () => import('@/components/PublicFace/Inventory/PaymentSuccess.vue'),
	},
	{
		path: '/Shop/:category',
		component: () => import('@/components/PublicFace/Inventory/InventorySearch.vue'),
		props: true
	},
	{
		path:'/Shop/Product/:product_name',
		name:'ViewProduct',
		component: () => import('../components/Products/ViewProductPage.vue'),
	},
	{
		path:'/Events',
		name:'EventsPage',
		component: () => import('../components/Events/EventsPage.vue')
	},
	{
		path:'/Events/Table',
		name: 'EventsTable',
		component: () => import('../components/Events/EventsTable.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/Events/Edit/:event_id',
		name: 'EditEvent',
		component: () => import('../components/Events/EditEventPage.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/Events/new_event',
		name: 'NewEvent',
		component: () => import('../components/Events/EditEventPage.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/Events/:event_slug',
		name: 'ViewEvent',
		component: () => import('../components/Events/ViewEventPage.vue'),
		props: true
	},
	{
		path:'/FixVVT',
		name: 'FixVVT',
		component: () => import('../components/VVTFIX/SubmitFilePage.vue'),
		meta: { permissions: ["correct_vvt_file"] },
		beforeEnter: authGuard
	},
	{
		path:'/FixVVT/List',
		name: 'VVTFixList',
		component: () => import('../components/VVTFIX/ViewVVTFixesPage.vue'),
		meta: { permissions: ["edit:vvt_fixes"] },
		beforeEnter: authGuard
	},
	{
		path:'/SubaruKeysAdmin',
		name: 'SubaruKeysAdmin',
		component: () => import('../components/SubaruKeyAdmin/AdminSupportPage.vue'),
		meta: { permissions: ["read:jobs"] },
		beforeEnter: authGuard
	},
	{
		path:'/SubaruKeysAdmin',
		name: 'SubaruKeysAdmin',
		component: () => import('../components/SubaruKeyAdmin/AdminSupportPage.vue'),
		meta: { permissions: ["read:jobs"] },
		beforeEnter: authGuard
	},
	{
		path:'/GM/VIN-Lookup',
		name: 'GMVINLookup',
		component: () => import('../components/GM Vin Processing/InputVin.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path:'/GM/CompareProfiles',
		name: 'GMCompareProfiles',
		component: () => import('../components/GM Vin Processing/VehicleProfileComparer.vue'),
		meta: { permissions: ["isEmployee"] },
		beforeEnter: authGuard
	},
	{
		path: '/:catchAll(.*)',
		redirect: '/',
	}

]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes: routes,
	scrollBehavior() {
		// Always scroll to top
		return { top: 0, left: 0 }
	}
})



export default router;
